export default "__VITE_ASSET__CZsRV7E6__"